'use client';

import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { useEffect } from 'react';

/** @internal nextjs */
export default function GlobalError({ error }: { error: unknown }) {
	useEffect(() => {
		Sentry.captureException(error);
	}, [error]);

	return (
		<html lang="de">
			<body>
				<NextError statusCode={500} />
			</body>
		</html>
	);
}
